export const allowedContexts: AllowedContexts = {
  all: ['brand_page', 'category', 'product_page', 'home', 'search'],
  category: ['brand_page', 'category', 'product_page', 'home'],
  keyword: ['search']
}
